export default "__VITE_ASSET__CbGT2By2__"